import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { DataFileDocumentsSystemModel, FileDocumentsSystemModel } from '../../models/configuration/file-documents-system.model';

export class
UpdateFileDocumentsSystemUseCase
implements UseCase<
DataFileDocumentsSystemModel,
FileDocumentsSystemModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        params: DataFileDocumentsSystemModel
    ):
    Observable<FileDocumentsSystemModel> {

        return this.repository
            .updateFileDocumentsSystem(
                params
            );
    }
}